import { PeAutocompleteOptionsProps } from '@pe-libs/react-components/build/components/PeAutocomplete/types';
import get from 'lodash.get';
import set from 'lodash.set';
import { IndustryType } from '#modules/auth/reducers/types';
import { PeOnboardingSchema } from './schemas';
import { FormValuesType } from './types';

export const createIndustrySelect = (industries: IndustryType[]): PeAutocompleteOptionsProps[] =>
  industries
    .reduce<PeAutocompleteOptionsProps[]>((pV, cV) => {
      if (cV.attributes && cV.attributes.title) {
        const { title, name, _id, aliases } = cV.attributes;

        pV.push({
          labelId: name,
          value: _id ?? title,
          title,
          aliases: aliases ?? [],
        });
      }

      return pV;
    }, [])
    .sort((a, b) => (a.title as string).localeCompare(b.title as string));

export const validatePassword = (values: FormValuesType) =>
  PeOnboardingSchema.validate(values, { abortEarly: false })
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    .then(() => {})
    .catch((error: { inner: Array<{ path: string; message: string }>; name: string }) => {
      if (error.name !== 'ValidationError') {
        throw error;
      }

      return error.inner.reduce((errors, currentError) => {
        const errorPath = get(errors, currentError.path) as string;

        if (currentError.path !== 'page1.password') {
          return set(errors, currentError.path, currentError.message);
        }

        const newErrors =
          errorPath?.length > 0
            ? set(errors, currentError.path, [currentError.message, ...errorPath])
            : set(errors, currentError.path, [currentError.message]);

        return newErrors;
      }, {});
    });
